import { MARK_PATH } from "@/lib/mark";
import { type IconProps, Stroke } from "./base";

/** The mark, as a button glyph, the logo tile and the tab bar's envoy. */

/** The mark, bare, for a button: the arrow in the dark ink, or in `fill`
 * where the ink would not show. */
export function MarkIcon({
    className = "size-[13px]",
    fill = "#14201a",
}: {
    className?: string;
    fill?: string;
}) {
    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
            <path d={MARK_PATH} fill={fill} />
        </svg>
    );
}

/** The mark: the arrow on the gradient tile, with the glow. */
export function LogoMark({ size = 30, glow = true }: { size?: number; glow?: boolean }) {
    return (
        <span
            className={`grid shrink-0 place-items-center bg-grad ${glow ? "shadow-glow" : ""}`}
            style={{ width: size, height: size, borderRadius: Math.round(size * 0.3) }}
            aria-hidden="true"
        >
            <svg width={size * 0.53} height={size * 0.53} viewBox="0 0 24 24" fill="none">
                <path d={MARK_PATH} fill="#14201a" />
            </svg>
        </span>
    );
}

/** Your envoy, in the tab bar: the mark, outlined. */
export function EnvoyIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d={MARK_PATH} />
        </Stroke>
    );
}
